/**
 * 盘口成交明细
 */
import React, { useEffect, useState } from "react"
import { getStockPKTradeDataSSE } from "../../../../modules/quote/web"
import { LoadStatus } from "../../load_status"
import { PageType, StockSubType } from "../../pagetype"
import { quote_fs_trade_info, quote_item_fs_trade_info } from "../../quotedata/index"

export function PanKouTradeDetail(props: { data:any,quotecode: string ,pagetype:PageType,stocksubtype:StockSubType}) {
  const [tradeData, setTradeData] = useState<Array<string>>([])
  const [lastItem, setLastItem] = useState("")

  useEffect(() => {
    let sse = getStockPKTradeDataSSE(props.quotecode, (data: any) => {
      setTradeData(data.slice(0, 14))
      setLastItem(data[14])
    })
    return () => {
      try {
        sse.close()
      } catch (error) {}
    }
  }, [])

  return (
    <div className="pk-container">
      <p className="title_p">成交明细</p>
      <table className="deal_list" cellPadding="0" cellSpacing="0" width="100%">
        <tbody>
          <tr>
            <th>时间</th>
            <th>成交价</th>
            <th>成交量</th>
            {
              (props.stocksubtype == StockSubType.沪市主板 || props.stocksubtype == StockSubType.深市主板 || props.stocksubtype == StockSubType.创业板 || props.stocksubtype == StockSubType.深市指数) && <th>单数</th>
            }
          </tr>
        </tbody>
        <tbody>
          {tradeData.length > 0 &&
            tradeData.map((item: any, index: number) => {
              return (
                <tr key={index}>
                  <td>{quote_fs_trade_info[quote_item_fs_trade_info.时间](item).element}</td>
                  <td>{quote_fs_trade_info[quote_item_fs_trade_info.成交价](tradeData, lastItem, item, index, props.data, 15).pkElement}</td>
                  <td>{props.pagetype == PageType.沪深京指数?quote_fs_trade_info[quote_item_fs_trade_info.成交量_指数](item).element:quote_fs_trade_info[quote_item_fs_trade_info.成交量](item).element}</td>
                  {(props.stocksubtype == StockSubType.沪市主板 || props.stocksubtype == StockSubType.深市主板 || props.stocksubtype == StockSubType.创业板 || props.stocksubtype == StockSubType.深市指数) && <td>{quote_fs_trade_info[quote_item_fs_trade_info.单数](item).element}</td>}
                </tr>
              )
            })}
        </tbody>
      </table>
      {tradeData.length == 0 && <LoadStatus icon={false} title="暂无数据" className="com_tips" />}
    </div>
  )
}
